import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const WhyChooseUs = () => {
  return (
    <section className="py-5 bg-success text-white">
      <Container>
        <Row className="justify-content-center mb-4">
          <Col lg={8} className="text-center">
            <h2 className="fw-bold mb-3">Pourquoi utiliser SaTeCO+ ?</h2>
            <p className="lead">
              Notre solution se démarque par sa capacité à fournir des cartes de fertilité 
              dynamiques et précises, mises à jour mensuellement.
            </p>
          </Col>
        </Row>
        
        <Row>
          <Col md={6} lg={3} className="mb-4">
            <div className="p-4 bg-white text-dark rounded h-100">
              <h4 className="text-success">Économies substantielles</h4>
              <p>
                Appliquez les intrants seulement là où ils sont nécessaires, réduisant ainsi 
                les coûts liés aux engrais et à l'eau.
              </p>
            </div>
          </Col>
          
          <Col md={6} lg={3} className="mb-4">
            <div className="p-4 bg-white text-dark rounded h-100">
              <h4 className="text-success">Optimisation des ressources</h4>
              <p>
                Recommandations précises pour une utilisation plus ciblée et efficace des 
                ressources (engrais, eau).
              </p>
            </div>
          </Col>
          
          <Col md={6} lg={3} className="mb-4">
            <div className="p-4 bg-white text-dark rounded h-100">
              <h4 className="text-success">Gain de temps</h4>
              <p>
                Notre solution vous guide sur les zones spécifiques à traiter, évitant des 
                applications uniformes inutiles.
              </p>
            </div>
          </Col>
          
          <Col md={6} lg={3} className="mb-4">
            <div className="p-4 bg-white text-dark rounded h-100">
              <h4 className="text-success">Précision accrue</h4>
              <p>
                Carte dynamique permettant des ajustements précis en fonction des besoins réels 
                du sol et des cultures.
              </p>
            </div>
          </Col>
        </Row>
        
        <Row className="mt-4">
          <Col className="text-center">
            <p className="fst-italic">
              Exemple concret : Plutôt que d'appliquer 100 kg d'urée uniformément sur 10 hectares, 
              notre solution indique les zones spécifiques qui en ont réellement besoin.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUs;